import { PortableText } from "@portabletext/react";
import Toggle from "@/components/toggle";

import { portableTextComponents } from "../../lib/portableTextComponents";
import styles from "./Faq.module.scss";

export default function Faq({ faqs, title }) {
  const id = title.replace(/ /g, "-");

  // Manual 50/50 split
  const midpoint = Math.ceil(faqs.length / 2);
  const leftColumn = faqs.slice(0, midpoint);
  const rightColumn = faqs.slice(midpoint);

  return (
    <div className={styles.faq} id={id}>
      {title && <h2 className={styles.faq__title}>{title}</h2>}

      <div className={styles.faq__grid}>
        <div className={styles.faq__column}>
          {leftColumn.map((faq, index) => {
            if (!faq || (!faq.title && !faq.question)) return null;

            return (
              <div key={faq._id || index} className={styles.faq__item}>
                <Toggle title={faq.title || faq.question}>
                  <PortableText components={portableTextComponents} value={faq.body || []} />
                </Toggle>
              </div>
            );
          })}
        </div>

        <div className={styles.faq__column}>
        {rightColumn.map((faq, index) => {
            if (!faq || (!faq.title && !faq.question)) return null;

            return (
              <div key={faq._id || index} className={styles.faq__item}>
                <Toggle title={faq.title || faq.question}>
                  <PortableText components={portableTextComponents} value={faq.body || []} />
                </Toggle>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
